import { companyRoutes } from '@/router/routes/public/company';
import { dealRoutes } from '@/router/routes/public/deal';
import { simulationRoutes } from '@/router/routes/public/simulation';
import { subsidiaryRoutes } from '@/router/routes/public/subsidiary';
import type { RouteRecordRaw } from 'vue-router';

/**
 * Ambiente público
 */
export const publicRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Login',
    path: '/login',
    component: () => import('@/views/public/LoginScreen.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'FAQ',
    path: '/faq',
    component: () => import('@/views/public/FaqScreen.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'NewPassword',
    path: '/change-password/:token',
    props: true,
    component: () => import('@/views/public/CreateNewPassword.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'RecoverPassword',
    path: '/recover-password',
    component: () => import('@/views/public/RecoverPassword.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PrivacyPolicy',
    path: '/politica-privacidade',
    component: () => import('@/views/public/PrivacyPolicy.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'TermsOfUse',
    path: '/termo-de-uso',
    component: () => import('@/views/public/TermsOfUse.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'CookiePolicy',
    path: '/cookies',
    component: () => import('@/views/public/CookiesPolicy.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'Subscribe',
    path: '/cadastro',
    alias: ['/subscribe'],
    component: () => import('@/views/public/SubscribeScreen.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PreRegistration',
    path: '/pre-cadastro',
    component: () => import('@/views/public/PreRegistration.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'preRegistrationParameterized',
    path: '/pre-cadastro/:name',
    component: () => import('@/views/public/PreRegistration.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'AuthorizationBext',
    path: '/autorizacao-bext',
    component: () => import('@/views/public/AuthorizationBext.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'PreRegistrationCompleted',
    path: '/pre-cadastro-completo',
    component: () => import('@/views/public/PreRegistrationCompleted.vue'),
    meta: { requiresAuth: false },
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/public/404.vue'),
    meta: { requiresAuth: false },
  },
  ...dealRoutes,
  ...subsidiaryRoutes,
  ...simulationRoutes,
  ...companyRoutes,
];
